import React from 'react';
import { LANG_OPTIONS } from '../../builder/data/i18n.js';

export default function LangSelect({ lang, setLang }) {
  return (
    <div style={{position:'relative',display:'inline-flex',alignItems:'center'}}>
      <select
        value={lang}
        onChange={e => setLang(e.target.value)}
        style={{
          WebkitAppearance:'none',MozAppearance:'none',appearance:'none',
          background:'rgba(255,255,255,.06)',border:'1px solid var(--border2)',
          borderRadius:8,color:'var(--text)',fontSize:'.78rem',fontWeight:600,
          padding:'.3rem 2rem .3rem .55rem',cursor:'pointer',outline:'none',
          lineHeight:1.4,
        }}
      >
        {LANG_OPTIONS.map(o => (
          <option key={o.code} value={o.code} style={{background:'#0f1117',color:'#f1f5f9'}}>
            {o.flag} {o.name}
          </option>
        ))}
      </select>
      <span style={{position:'absolute',right:'.45rem',pointerEvents:'none',fontSize:'.6rem',color:'var(--dim)',lineHeight:1}}>▾</span>
    </div>
  );
}
